// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","Modal":"Modal","fadein":"fadein","ModalContent":"ModalContent","ModalNavItem":"ModalNavItem","closeButton":"closeButton","ModalNavigation":"ModalNavigation","ModalNavButton":"ModalNavButton","ModalNavNext":"ModalNavNext","closePanel":"closePanel","ModalBackground":"ModalBackground","fadeinBg":"fadeinBg"};


//////////////////
// WEBPACK FOOTER
// ./src/reactModules/shared/library/Modal/Modal.styl
// module id = 1045
// module chunks = 0